











































































































import Vue from 'vue';
import {Component, Prop, Watch} from "vue-property-decorator";
import UseDelayRepay from "./UseDelayRepay.vue";
import ContactCustomerServices from "./ContactCustomerServices.vue";
import AbandonedPickDirection from "./AbandonedPickDirection.vue";
import {Journey, JourneyScopeEnum, PurchaseRefundStatus} from "./DisruptionModels";

@Component({
    components: {AbandonedPickDirection, ContactCustomerServices, UseDelayRepay}
})
export default class DisruptionsApp extends Vue {

    @Prop() refundStatus: PurchaseRefundStatus;
    @Prop() journeyId: string;
    @Prop() email: string;

    claimsDisruption: boolean = false;
    reasonChosen: string = 'No'; // No, Strike or Yes
    notDecided: boolean = true;
    disruptionReason: string = '';
    done: boolean = false;

    mounted() {
        console.log(this.refundStatus.journeys[0].journeyID);
        console.log(this.relevantJourney.journeyID);
    }

    @Watch("reasonChosen")
    onReasonChosen(value: string, old: string) {
        this.claimsDisruption = value !== 'No';
    }

    @Watch("claimsDisruption")
    onClaimsDisruption(value: boolean, old: boolean) {
        if (value && window.localStorage.getItem(this.journeyId + '-reason')) {
            this.disruptionReason = window.localStorage.getItem(this.journeyId + '-reason');
            this.done = true;
        }
    }

    continueBtn() {
        this.notDecided = false;
    }

    doneFunc() {
        window.localStorage.setItem(this.journeyId + '-reason', this.disruptionReason);
        this.done = true;
    }

    redirectToConfirmWithAbandoned(scope: JourneyScopeEnum) {
        let disruptedOutwards = false;
        let disruptedInwards = false;

        switch(scope) {
            case JourneyScopeEnum.All:
                disruptedInwards = true;
                disruptedOutwards = true;
                break;
            case JourneyScopeEnum.In:
                disruptedInwards = true;
                break;
            case JourneyScopeEnum.Out:
                disruptedOutwards = true;
                break;

        }
        const params = new URLSearchParams({
            disruptedOutwards,
            disruptedInwards
        });
        window.location.href = `/ConfirmRefund${this.queryStr}&${params.toString()}`;
    }

    get relevantJourney(): Journey {
        return this.refundStatus.journeys.find(j => j.journeyID === this.journeyId);
    }

    private readonly DisruptionCode = '104';

    get hasDisruptionAvailable(): boolean {
        return this.relevantJourney.refundOptions.refundCodes.some(rc => rc.scopes.some(s => s.selfRefundPermitted) && rc.reasonCode === this.DisruptionCode);
    }

    get queryStr(): string {
        return window.location.search;
    }

}

